import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const wideScreen = '(max-width: 1380px)';
const midScreen = '(max-width: 740px)';

const QuoteWrapper = styled.div`
  max-width: 300px;
  &.quote--left {
    text-align: right;
    margin-left: calc(((100vw - 700px) / 2) - 320px); 
    float: left;
    &:after {
      content: '';
      display: table;
      clear: both;
    }
    @media ${wideScreen} {
      margin: 4rem auto;
      max-width: 700px;
      float: none;
      padding: 0 20px;
      text-align: left;
    }
  }
  &.quote--right {
    float: right;
    text-align: left;
    margin-right: calc(((100vw - 700px) / 2) - 320px);
    @media ${wideScreen} {
      margin: 4rem auto;
      padding: 0 20px;
      max-width: 700px;
      float: none;
      text-align: left;
    }
  }
`;

const Quote = styled.blockquote`
  font-size: 2.125rem;
  line-height: 3rem;
  color: var(--custom-white);
  @media ${wideScreen} {
    font-size: 1.75rem;
    line-height: 2.25rem;
  }
  @media ${midScreen} {
    font-size: 1.375rem;
    line-height: 1.75rem;
  }
`;

const Attribution = styled.p`
  font-size: 0.875rem;
  line-height: 1rem;
  color: white;
  margin-top: 0.5rem;
`;

const InitialLetter = styled.span`
  position: relative;
  &:before {
    content: '“';
    position: absolute;
    left: 0;
    top: 0;
    color: var(--custom-red);
    opacity: 0.3;
    font-size: 300px;
    transform: translate(-70%, 150%);
    z-index: -1;
    @media ${wideScreen} {
      font-size: 225px;
    }
    @media ${midScreen} {
      font-size: 160px;
    }
  }
  &.right {
    :before {
      transform: translate(-20%, 150%);
    }
  }
`;

const Pullquote = ({ quote, attribution, alignment }) => {
  const quoteClass = `quote--${alignment}`;
  const quoteFirstLetter = quote.slice(0, 1);
  const quoteRemainder = quote.substring(1);
  return (
    <QuoteWrapper className={quoteClass}>
      <Quote className="millerbanner-n4">
        <InitialLetter className="right">{quoteFirstLetter}</InitialLetter>{quoteRemainder}
      </Quote>
      <Attribution className="benton-n4">— {attribution}</Attribution>
    </QuoteWrapper>
  );
};

export default Pullquote;

Pullquote.propTypes = {
  quote: PropTypes.string.isRequired,
  attribution: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired,
};
